import { ChangePhotoForm } from "./components";

const ChangePhotoModal = () => {
  return <ChangePhotoForm />;
};

export { ChangePhotoModal };
